<template>
  <v-app>
    <AdminNavigation :all-messages="messages" />
    <v-main ref="main" class="content content--more-pad" :style="top">            
      <v-container v-if="loaded" class="pr-md-12 pl-md-12">        
        <router-view />
      </v-container>
    </v-main>
  </v-app>
</template>
<script>

import AdminNavigation from '@/components/admin/AdminNavigation'
import {mapState, mapMutations } from 'vuex'
import { SET_USER, LOCK_BOTTOM_NAV, UNLOCK_BOTTOM_NAV, SET_ALERTS_SHOWN} from '@/store/appMutations'    
import { APP_USER,  APP_ALERTS_SHOWN} from '@/store/appStates'
import { setAuthHeader } from '@/backend/axios'
import api from '@/backend/api'
import log from '@/logger'

export default {
  name:'AdminLayout',
  components: { AdminNavigation},
  data() {
    return {
      alerts: [],           
      showAlert:false,
      messages:[],    
      loaded:false
    }
  },
  computed: {
    ...mapState({    
      user:state => state[APP_USER],
      hasShowedAlerts:state => state[APP_ALERTS_SHOWN]      
    }),
     authorized(){
      if(this.user === undefined){        
        return false
      }
      if(this.user.token !== undefined){
        setAuthHeader(this.user.token)
        return true
      }
      return false
    },
    
    top(){
        return 'top:88px'    
    }   
  },  
  watch: {
    authorized(value) {
      // Login in the nav happens after created(), so loaded must follow it.
      if (value) {
        this.loaded = true
      }
    },
  },
  created() {   
    var token = this.$cookies.get('auth_admin_token')
    if(token !== undefined && token !== null)
    {
      var jwt = JSON.parse(atob(token.split('.')[1]))
      log.debug(jwt)
      if(jwt.sub !== 'admin'){
        this.$router.push({name:'start'})
      }
      setAuthHeader(token)
      api.validateAdmin(token)
          .then(resp => {
            const newToken = resp.data.token   
            if(newToken !== token){
              setAuthHeader(token)
              log.debug('Setting token:', token)
              
              if(this.$cookies.get('auth_admin_token') === undefined){
                this.$cookies.set('auth_admin_token',token, null,null, 'kvallstidningarna.se')
              }
            }           
            this.setUser(resp.data)        
            this.loaded = true    
            log.debug('admin layout- loaded')
           
          })
          .catch(err => {
            this.valid = false
            log.debug(err)
            if (err.response && err.response.status === 400) {
              this.message = err.response.data
            }            
            this.$router.push({name:'login'})
          })              
    }
    if(this.authorized){
      this.loaded = true    
      log.debug('admin layout- loaded')
    }
  },
  mounted(){
    this.loadData()
  },
  methods: {
    ...mapMutations({
      setUser: SET_USER,
      lockNav:LOCK_BOTTOM_NAV,
      unlockNav: UNLOCK_BOTTOM_NAV,
      setAlertsShown: SET_ALERTS_SHOWN
    }),          
    loadData() {
    
     
    },
  }
}
</script>

<style lang="scss">
  @import '../sass/app.scss';
</style>

<style lang="scss" scoped>
  .v-application{
    font-family: 'AkzidenzGroteskBE'!important;
  }
</style>
